<script setup>
import DynamicField from './DynamicField.vue';

const props = defineProps({
    schema: Array,
    model: Object
});
</script>
<template>
    <div v-for="field in props.schema" :key="field.path" class="allegro-description">
        <dynamic-field :field="field" :model="props.model" />
    </div>
</template>
<style>

</style>